export type ConfirmState = "idle" | "match" | "mismatch";

export const confirmState = (
  password: string,
  confirm: string,
  submitted: boolean
): ConfirmState => {
  if (confirm.length > 0 && confirm === password) {
    return "match";
  }
  const mismatch =
    (confirm.length > 0 && confirm.length >= password.length) ||
    (submitted && confirm !== password);
  return mismatch ? "mismatch" : "idle";
};

export const confirmMessage = (
  password: string,
  confirm: string,
  submitted: boolean
): string | null => {
  const state = confirmState(password, confirm, submitted);
  if (state === "match") {
    return "Passwords match.";
  }
  if (state !== "mismatch") {
    return null;
  }
  if (!confirm) {
    return "Re-enter your password to confirm it.";
  }
  return "Passwords don’t match.";
};
